.customModal {
    max-width: 500px;
    width: 100%;
    padding: 25px;
    border-radius: 4px;
}

.customCloseButton {
    top: 23px;
    right: 21px;
}
